import store from '../store/modules/paramsClient-data.js';

const totalSegmentDuration = () => {
  return +store.state.paramsClient.default_segment_duration || 20;
};

const isMultipleBy30 = () => {
  return (
    +store.state.paramsClient.default_segment_duration === 30 &&
    +store.state.paramsClient.nb_screen_segment !== 1
  );
};

const canEditDuration = () => {
  return store.state.permissions.edit_duration_segment_action;
};

const updateSlidesDuration = (segment, segmentDuration = totalSegmentDuration()) => {
  if (canEditDuration()) {
    return segment;
  }
  let segmentShadow = JSON.parse(JSON.stringify(segment));
  const startGeneric = segmentShadow.find(s => s.type === 'startGeneric');

  const length = segmentShadow.length - (startGeneric ? 1 : 0);
  let duration = segmentDuration;

  if (startGeneric) {
    duration = Math.max(duration - startGeneric.options.duration, 0);
  }
  segmentShadow = segmentShadow.map((slide, index) => {
    if(typeof slide.options ==="string"){
      slide.options = JSON.parse(slide.options);
    }
    if (slide.type === 'startGeneric') {
      slide.options.duration = Math.min(slide.options.duration, segmentDuration);
    } else {
      slide.options.duration = Math.floor(+duration / length);

      if (index === segmentShadow.length - 1) {
        slide.options.duration += +duration % length;
      }
    }
    return slide;
  });
  return segmentShadow;
};

const updateSegmentDuration = segments => {
  if (canEditDuration()) {
    return segments;
  }
  const startGeneric = segments.find(s => s.type === 'startGeneric');
  const finishGeneric = segments.find(s => s.type === 'finishGeneric');

  let segmentWithFullScreen = segments
    .filter(function(segmentf) {

      return segmentf.screens.find(s => s.options.fullscreenVideo === true);
    })
    .map((segment, index) => {
      return segment;
    });
  let AllDuration = segmentWithFullScreen.reduce((sum, e) => sum + +(e.duration || 0), 0);
  let segmentWithoutFullScreen = segments.filter(function(segmentf) {
    return segmentf.screens.every(s => s.options.fullscreenVideo !== true);
  });
  /*todo mode 30 */
  let durationMod30 = AllDuration && AllDuration > 0 ? AllDuration % 30 : 0;
  let lengthStartGeneric = startGeneric ? 1 : 0;
  let lengthFinishGeneric = finishGeneric ? 1 : 0;
  let lengthSegments = segmentWithoutFullScreen.length - lengthStartGeneric - lengthFinishGeneric;
  durationMod30 = durationMod30 > 0 ? (durationMod30 > 15 ? 30 - durationMod30 : durationMod30) : 0;
  let newDuration = durationMod30 > 0 ? Math.floor(durationMod30 / lengthSegments) : 0;
  newDuration = newDuration > 0 ? newDuration : 0;
  let hasModDuration = durationMod30 ? durationMod30 % lengthSegments : 0;
  let durationNew = 0;
  let durationNewLast = 0;

  segments.map((segment, index) => {
    if (segment.screens.find(s => s.options.fullscreenVideo === true)) {
      durationNewLast = segment.duration;
      durationNewLast =
        durationNewLast && durationNewLast > 0 ? (durationNew + durationNewLast) % 30 : durationNew;
      durationNew = durationNewLast > 15 ? durationNewLast - 30 : durationNewLast;

      return segment;
    }

    let duration = segment.originalDuration || totalSegmentDuration();

    if (!segment.type.toLowerCase().includes('generic')) {
      let durationS =
        duration - durationNew < 0 ? duration - durationNew + 30 : duration - durationNew;
      segment.duration =
        duration - durationNew < 0 ? duration - durationNew + 30 : duration - durationNew;
      segment.screens = updateSlidesDuration(segment.screens, durationS);
      durationNew = 0;
    }

    return segment;
  });
  let seg = segments
    .filter(function(segmentf) {
      return segmentf.screens.every(s => s.options.fullscreenVideo !== true);
    })
    .filter(s => s.type !== 'startGeneric')
    .filter(s => s.type !== 'finishGeneric');
  if (durationNew !== 0) {
    if (seg[seg.length - 1])
      seg[seg.length - 1].duration =
        seg[seg.length - 1].duration - durationNew < 0
          ? seg[seg.length - 1].duration - durationNew + 30
          : seg[seg.length - 1].duration - durationNew;
  }

  if (!!startGeneric) {
    if (seg[0])
      seg[0].duration =
        seg[0].duration - startGeneric.duration < 0
          ? seg[0].duration - startGeneric.duration + 30
          : seg[0].duration - startGeneric.duration;
  }
  if (!!finishGeneric) {
    if (seg[seg.length - 1])
      seg[seg.length - 1].duration =
        seg[seg.length - 1].duration - finishGeneric.duration < 0
          ? seg[seg.length - 1].duration - finishGeneric.duration + 30
          : seg[seg.length - 1].duration - finishGeneric.duration;
  }

  segments.map((segment, index) => {
    if (segment.screens.find(s => s.options.fullscreenVideo === true)) {
      return segment;
    }
    if (!segment.type.toLowerCase().includes('generic')) {
      segment.screens = updateSlidesDuration(segment.screens, segment.duration);
    }
    return segment;
  });
  return segments;
};

const updateSegmentOriginalDuration = segments => {
  if (canEditDuration()) {
    return segments;
  }
  const startGeneric = segments.find(s => s.type === 'startGeneric');
  const finishGeneric = segments.find(s => s.type === 'finishGeneric');
  let durationNewLast = 0;
  let durationNew = 0;
  segments.map((segment, index) => {
    if (segment.screens.find(s => s.options.fullscreenVideo === true)) {
      durationNewLast = segment.duration;
      durationNewLast =
        durationNewLast && durationNewLast > 0 ? (durationNew + durationNewLast) % 30 : durationNew;
      durationNew = durationNewLast > 15 ? durationNewLast - 30 : durationNewLast;
      return segment;
    }
    let duration = 0;

    if (!segment.type.toLowerCase().includes('generic')) {
      duration = segment.duration;
      let durationS = duration + durationNew;
      segment.originalDuration = durationS;
      durationNew = 0;
    }

    return segment;
  });

  let seg = segments
    .filter(function(segmentf) {
      return segmentf.screens.every(s => s.options.fullscreenVideo !== true);
    })
    .filter(s => s.type !== 'startGeneric')
    .filter(s => s.type !== 'finishGeneric');
  if (durationNew !== 0) {
    if (seg[seg.length - 1]) {
      let duration1 = seg[seg.length - 1].originalDuration || seg[seg.length - 1].duration || totalSegmentDuration();


      seg[seg.length - 1].originalDuration = duration1 + durationNew;


    }
  }
  if (!!startGeneric) {
    if (seg[0]) {
      let duration2 = seg[0].originalDuration || totalSegmentDuration();
      seg[0].originalDuration = duration2 + startGeneric.duration;
    }
  }
  if (!!finishGeneric) {
    if (seg[seg.length - 1]) {
      let duration3 = seg[seg.length - 1].originalDuration || totalSegmentDuration();
      seg[seg.length - 1].originalDuration = duration3 + finishGeneric.duration;
    }
  }
  return segments;
};

export {
  updateSlidesDuration,
  totalSegmentDuration,
  updateSegmentDuration,
  isMultipleBy30,
  updateSegmentOriginalDuration,
};



// WEBPACK FOOTER //
// ./src/helpers/duration-handler.js